import { useSyncExternalStore } from 'react';

export type DevBannerKey =
  | 'disconnect'
  | 'powerOn'
  | 'agentError'
  | 'agentStarting'
  | 'agentStopping'
  | 'poweredOff'
  | 'demoSignIn'
  | 'anonSignIn'
  | 'vmBoot'
  | 'workingBubble'
  | 'selfInitiatedTask'
  | 'railPill'
  | 'forceArtifact'
  | 'paymentRequired'
  | 'paymentRequiredAnon'
  | 'chatErrorUnknown';

export type DevBannerOverrides = Record<DevBannerKey, boolean>;

const initial: DevBannerOverrides = {
  disconnect: false,
  powerOn: false,
  agentError: false,
  agentStarting: false,
  agentStopping: false,
  poweredOff: false,
  demoSignIn: false,
  anonSignIn: false,
  vmBoot: false,
  workingBubble: false,
  selfInitiatedTask: false,
  railPill: true,
  forceArtifact: false,
  paymentRequired: false,
  paymentRequiredAnon: false,
  chatErrorUnknown: false,
};

let state: DevBannerOverrides = initial;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => state;

export const setDevBannerOverride = (key: DevBannerKey, value: boolean) => {
  if (state[key] === value) return;
  state = { ...state, [key]: value };
  listeners.forEach((l) => l());
};

export const toggleDevBannerOverride = (key: DevBannerKey) => {
  setDevBannerOverride(key, !state[key]);
};

export const useDevBannerOverrides = (): DevBannerOverrides =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
